import { cn } from '@/lib/utils';
import React, { FC, useState } from 'react';
import ImageIconSolid from '@/components/icons/ImageIconSolid';

type Props = {
	src?: string;
	alt?: string;
	fallbackSVG?: React.FC<React.SVGProps<SVGSVGElement>>;
	fallbackClassName?: string;
	containerClassName?: string;
	imageClassName?: string;
};

const EImageWithFallback: FC<Props> = ({
	src,
	alt = 'Card image',
	fallbackSVG: FallbackIcon = ImageIconSolid,
	fallbackClassName = 'size-16 fill-popover-400',
	containerClassName,
	imageClassName,
}) => {
	const [hasError, setHasError] = useState(false);

	return (
		<div className={cn('w-full h-full shrink-0', containerClassName)}>
			{!src || hasError ? (
				<div className='min-w-full h-full flex items-center justify-center bg-popover-100'>
					<FallbackIcon className={fallbackClassName} />
				</div>
			) : (
				<img
					src={src}
					alt={alt}
					className={cn('w-full h-full object-cover', imageClassName)}
					onError={() => setHasError(true)}
				/>
			)}
		</div>
	);
};

export default EImageWithFallback;
